import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

// Status/QR da instancia pessoal do usuario (banco master). Reaproveita o tipo
// GetConfiguracoesInstacia, identico ao retorno da instancia da organizacao.
export const getUserWhatsAppInstancia = async (
  id: number
): Promise<GetConfiguracoesInstacia | { message: string }> => {
  try {
    const result = await apiService.get(
      `central/usuario/${id}/integracaowhatsapp/instancia`
    )
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

// Ativa o WhatsApp pessoal. O backend cria a instancia automaticamente (nome
// "Predict - user - <id>") quando ainda nao existe — sem entrada manual de id/token.
export const ativarUserWhatsApp = async (
  id: number
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.post(
      `central/usuario/${id}/integracaowhatsapp`,
      { ativo: true }
    )
    if (result.status === 200) {
      return { info: 'WhatsApp pessoal ativado!' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

// Desconecta (logout) a instancia pessoal na Evolution.
export const deletaUserWhatsAppInstancia = async (
  id: number
): Promise<{ sucesso: string } | { message: string }> => {
  try {
    const result = await apiService.delete(
      `central/usuario/${id}/integracaowhatsapp/instancia`
    )
    if (result.status === 200) {
      return { sucesso: 'Instância desconectada!' }
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}
